import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_418: DocMigration = {
  maxSchemaVersion: "0.0.418",
  description: "Add entity tags to Prop catalog items and recategorize trellis props",
  apply(json: any) {
    // set prop category
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];

      if (setting.type === "EXTERIOR_PROP_SETTINGS" || setting.type === "INTERIOR_PROP_SETTINGS") {
        const { propTypes } = setting;
        for (const propType in propTypes) {
          const propAttributes = propTypes[propType];

          if (!propAttributes) {
            continue;
          }

          if (propAttributes.propAssetId && otherPropAssetIdToName[propAttributes.propAssetId.toString()]) {
            // These props should not be classified as FURNITURE, but should also not show on the built in plans
            propAttributes.category = "OTHER";
            propAttributes.tags = {};
          } else {
            propAttributes.tags = {
              addToElectricalPlan: true,
              addToFloorPlan: true,
              addToStructuralPlan: true,
              addToBrochurePlan: true,
              addToFloorMaterialsPlan: true,
              addToFloorSummaryPlan: true,
            };
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_418;

const otherPropAssetIdToName = {
  "53": "Arch_GarageTrellis_10_01",
  "54": "Arch_GarageTrellis_16_01",
  "55": "Arch_GarageTrellis_17_01",
  "56": "Arch_GarageTrellis_18_01",
  "57": "Arch_GarageTrellis_Capital_08f11_01",
  "58": "Arch_GarageTrellis_Capital_08f8_01",
  "59": "Arch_GarageTrellis_Capital_09f7_01",
  "60": "Arch_GarageTrellis_Capital_16f11_01",
  "61": "Arch_GarageTrellis_Capital_16f8_01",
  "62": "Arch_GarageTrellis_Capital_17f7_01",
};
